import { isEqual } from 'lodash';
import React from 'react';
import CustomSelect from '../../../components/forms/CustomSelect';
import CustomTextDelayInput from '../../../components/forms/CustomTextDelayInput';
import DateField from '../../../components/forms/DateField';
import { usePrivilege } from '../../../components/priviledge/PriviledgeProvider';
import useCategories from '../../../hooks/api-calls/useCategories';
import useCompanies from '../../../hooks/api-calls/useCompanies';
import useUnitsMeasure from '../../../hooks/api-calls/useUntisMeasure';

interface ProductsFiltersProps {
    updateFilters: (filters: any) => void;
    filters: any;
}

const ProductsFilters: React.FC<ProductsFiltersProps> = ({ filters, updateFilters }) => {

    // HOOKS

    const { userCan } = usePrivilege();
    const { getCategoriesList } = useCategories();
    const { getUnitsMeasureList } = useUnitsMeasure();
    const { getCompaniesList } = useCompanies();

    // RENDER 

    return (
        <>
            <CustomTextDelayInput
                id="name"
                label="Nombre"
                placeholder="Buscar por nombre"
                filters={filters}
                updateFilters={updateFilters}
            />

            {userCan('list', 'category') && (
                <CustomSelect
                    isSearchable
                    id={'category'}
                    label="Categoría"
                    options={getCategoriesList()}
                    onChange={(e: any) => {
                        if (e.value === 'null') {
                            updateFilters({ category: null });
                            return;
                        }
                        updateFilters({ category: e.value });
                    }}
                    value={getCategoriesList().find((item: any) => item.value === filters.filter_filters?.category) ?? { label: 'Todas', value: 'null' }}
                />
            )}

            {userCan('list', 'unit_measure') && (
                <CustomSelect
                    isSearchable
                    id="unit_measure"
                    label="Unidad de medida"
                    options={getUnitsMeasureList()}
                    value={getUnitsMeasureList().find((item: any) => item.value === filters.filter_filters?.unit_measure) ?? { label: 'Todas', value: 'null' }}
                    onChange={(e: any) => {
                        if (e.value === 'null') {
                            updateFilters({ unit_measure: null });
                            return;
                        }
                        updateFilters({ unit_measure: e.value });
                    }}
                />
            )}

            <CustomSelect
                isSearchable
                id={'active'}
                label="Estado"
                options={[
                    { label: 'Todos', value: 'null' },
                    { label: 'Activos', value: true },
                    { label: 'Desactivados', value: false }
                ]}
                onChange={(e: any) => {
                    if (e.value === 'null') {
                        updateFilters({ active: null });
                        return;
                    }
                    updateFilters({ active: e.value });
                }}
                value={filters.filter_filters?.active !== null && filters.filter_filters?.active !== undefined
                    ? { label: filters.filter_filters?.active ? 'Activo' : 'Desactivado', value: filters.filter_filters?.active }
                    : { label: 'Todos', value: 'null' }}
            />

            <DateField
                isClearable
                className="w-full"
                label="Fecha de Creación"
                placeholderText="Selecciona las fechas"
                selectedDateField={filters.filter_filters?.between_dates?.type || "createdAt"}
                dateTypesOptions={[
                    { label: "Fecha de creación", value: "createdAt" },
                    { label: "Fecha de modificación", value: "updatedAt" }
                ]}
                startDate={filters.filter_filters?.between_dates?.startDate ? new Date(filters.filter_filters.between_dates.startDate) : null}
                endDate={filters.filter_filters?.between_dates?.endDate ? new Date(filters.filter_filters.between_dates.endDate) : null}
                onChange={(date: any) => {
                    const filters_between_dates = filters.filter_filters?.between_dates;
                    const between_dates = date ? { startDate: date[0], endDate: date[1] } : null;

                    if (between_dates && !isEqual(filters_between_dates, between_dates)) {
                        updateFilters({ between_dates: { startDate: date[0], endDate: date[1], type: date[2] } });
                    } else if (!between_dates && filters_between_dates) {
                        updateFilters({ between_dates: null });
                    }
                }}
            />

            {userCan('list', 'company') && (
                <CustomSelect
                    isSearchable
                    id="company"
                    label="Compañía"
                    options={getCompaniesList()}
                    value={getCompaniesList().find((item: any) => item.value === filters.filter_filters?.company) ?? { label: 'Todas', value: 'null' }}
                    onChange={(e: any) => {
                        if (e.value === 'null') {
                            updateFilters({ company: null });
                            return;
                        }
                        updateFilters({ company: e.value });
                    }}
                />
            )}

        </>
    );
};

export default ProductsFilters;